"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnHkUsd = exports.EnHkHkd = void 0;
class EnHkHkd {
    constructor() {
        this.locale = "en-hk";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "HKD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnHkHkd = EnHkHkd;
class EnHkUsd {
    constructor() {
        this.locale = "en-hk";
        this.dateFormat = {
            short: "MM/dd/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "USD",
            symbol: "$",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnHkUsd = EnHkUsd;
